var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartPointArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#4E4E4E",
  strokeLinecap: "round",
  strokeWidth: 1.25,
  d: "m7 16 1.714-3.429a1 1 0 0 1 1.736-.093l2.335 3.632c.468.729 1.578.558 1.806-.277L17 7m-3 1.498 3.167-1.829 1.829 3.167M8 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
})));
export default SvgChartPointArrow;